// CHAT.WORKSPACE.CHAINE.1 lot 5 (K4 de DEC-CHAINE-CHAT-2) : l'écran envoie et montre l'étape du greffier (etape_suggeree de /elements),
// la même que Carlos reçoit ; sans étape du greffier, le comportement d'avant (chatStage, avancé par les blocs de cristallisation).

const CREDO_STEPS = ["comprendre", "rechercher", "exposer", "demontrer", "objectif"];
// même correspondance que le serveur (api_rest.py, étape → phase de la consigne)
const ETAPE_VERS_STEP: Record<string, string> = {
  objectif: "comprendre", situation: "rechercher", pistes: "exposer", decisions: "demontrer", plan: "objectif",
};

/** La phase envoyée avec le message du chat (workspace_phase). */
export function phaseEnvoyee(etape: string | undefined | null, chatStage: number, activePhase: string, enDiscussion: boolean): string {
  if (!enDiscussion) return activePhase;
  const step = ETAPE_VERS_STEP[etape || ""];
  if (step) return `discussion_${step}`;
  return chatStage < CREDO_STEPS.length ? `discussion_${CREDO_STEPS[chatStage]}` : activePhase;
}

/** L'identifiant de l'étape de l'écran (credo-<lettre>-…) qui correspond à l'étape du greffier ; null sans étape. */
export function etapeMontree(steps: { id: string }[], etape: string | undefined | null): string | null {
  const step = ETAPE_VERS_STEP[etape || ""];
  if (!step) return null;
  return steps.find(s => s.id.includes(step))?.id ?? null;
}
